module.exports = __webpack_public_path__ + "media/images/menu/aurorae-8fc518d0c3d605af5849661e242db3d7.jpg";